// src/utils/serviceOptions.js
import { useTranslation } from 'react-i18next';

export const useServiceOptions = () => {
  const { t } = useTranslation();

  return [
    {
      id: 'whatsappResponder',
      label: t('features.whatsappChatbot.title'),
      description: t('features.whatsappChatbot.description')
    },
    {
      id: 'campaignAssistant',
      label: t('features.ads.title'),
      description: t('features.ads.description')
    },
    {
      id: 'digitalCatalog',
      label: t('features.digitalCatalog.title'),
      description: t('features.digitalCatalog.description')
    },
    {
      id: 'orderForm',
      label: t('features.onlineOrders.title'),
      description: t('features.onlineOrders.description')
    },
    {
      id: 'crmLite',
      label: t('features.crmLite.title'),
      description: t('features.crmLite.description')
    },
    {
      id: 'qrFlyers',
      label: t('features.qrFlyers.title'),
      description: t('features.qrFlyers.description')
    },
    {
      id: 'onlinePayments',
      label: t('features.onlinePayments.title'),
      description: t('features.onlinePayments.description')
    }
  ];
}